import { IAppInsightsConfig } from '@careerhub/common';

export function getTelemetryConfig(history: any): IAppInsightsConfig {
  return {
    serviceOffering: 'Human Resources',
    serviceLine: 'Talent and Learning',
    service: 'HR Career Development',
    componentName: 'Talent Marketplace',
    componentId: '0a8f2bf4-3f0c-4d03-8a6d-ef5e50a5e7bb',
    environmentName: __IS_DEVELOPMENT__ === true ? 'Non-Production' : 'Production',
    iKey: __INSTRUMENTATION_KEY__,
    history,
  };
}
